import CrudModel from 'model-fns';
import xtend from 'xtend';
import Effects from '../../effects';
var crudModel = CrudModel('eventID');

function EventsModel (api) {
    function model () {
        return xtend(crudModel(), { hasFetched: false });
    }

    model.effects = Effects(api.events);

    model.update = xtend(crudModel.update, {
        get: function (state, ev) {
            return xtend(crudModel.update.get(state, ev), {
                hasFetched: true
            });
        }
    });

    return model;
}

export default EventsModel;
